import { ObjectPlugin } from "vue";

const devicePlugin = () => {
  return {
    isMobile: false,
    isMobileOrTablet: false,
  } as const;
};

export type DevicePlugin = ReturnType<typeof devicePlugin>;

export const $device: ObjectPlugin = {
  install: (app, _) => {
    app.config.globalProperties.$device = devicePlugin();
  },
};

export default $device;
